import * as moment from 'moment';
import { EvaluationJure } from './evaluation-jure.model';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class EvaluationJureCommission {
    static jsonMap = {
        dateCommission: { key: 'dateCommission', converter: new DateConverter() },
        evaluations: { key: 'evaluations', converter: new (ArrayClassConverterFactory.build(EvaluationJure))() }
    };

    dateCommission: moment.Moment;
    evaluations: EvaluationJure[];
}
